import { useTranslation } from 'react-i18next'
import { Star } from 'lucide-react'
import { cn } from '@/lib/utils'

interface FavouriteToggleProps {
  recipeId: string
  name: string
  isFavourite: boolean
  isPending: boolean
  onToggle: (recipeId: string, isFavourite: boolean) => void
}

export function FavouriteToggle({ recipeId, name, isFavourite, isPending, onToggle }: FavouriteToggleProps) {
  const { t } = useTranslation('recipes')

  return (
    <button
      type="button"
      onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
        onToggle(recipeId, !isFavourite)
      }}
      disabled={isPending}
      aria-label={t('favourites.toggleAriaLabel', {
        name,
        state: isFavourite ? t('favourites.unfavourite') : t('favourites.favourite'),
      })}
      aria-pressed={isFavourite}
      className={cn(
        'flex items-center justify-center min-h-[44px] min-w-[44px] rounded-lg',
        'motion-safe:transition-colors disabled:opacity-50',
      )}
    >
      <Star
        className={cn(
          'h-5 w-5',
          isFavourite ? 'fill-accent text-accent' : 'text-stone-400',
        )}
        aria-hidden="true"
      />
    </button>
  )
}
